import SpinIcon from './SpinIcon';

export default SpinIcon;
